import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import App from "./App";
import "./index.css";
import "./i18n";

import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/_reset.scss";
import "./assets/styles/_global.scss";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <ToastContainer style={{ top: "80px" }} />
    </BrowserRouter>
  </React.StrictMode>
);
